// import {range} from 'd3-array';
// import {scaleQuantile} from 'd3-scale';
import _ from 'lodash'


function getRGBA(color) {
  const {r,g,b,a} = color

  const rr = r > 0 ?  Math.floor(255*r) : 0
  const gg = g > 0 ?  Math.floor(255*g) : 0
  const bb = b > 0 ?  Math.floor(255*b) : 0

  if(rr > 255 || gg > 255 || bb > 255)
    return `rgba(${r}, ${g}, ${b}, ${a})`; // this is an error

  return `rgba(${rr}, ${gg}, ${bb}, ${a})`;
}


export const createGeoJsonDataFromGeoFire = (geoFire) => {

  // filter out sessions without l data and create coordinates array
  _cleanSessions(geoFire)

  let features = []
  let pointID = 0
  let lineID = 0

  _.map(geoFire, (session, sessionKey) => {
    pointID++

    // const radius = _.size(session.lines);
    // Add session as a circle
    const pointFeature = {
      "type": "Feature",
      "geometry": { "type": "Point", "coordinates": [round(session.coordinates[0], 4), round(session.coordinates[1], 4)]  },
      "properties" : {
        "id": pointID,
        // "userId": session.userId,
        "color": getRGBA(_.find(session.lines, 'color').color),
      }
    };
    features.push(pointFeature);

    // add lines to map
    _.map(session.lines, (line, lineKey) => {
      lineID++

      const lineFeature = {
        "type": "Feature",
        "geometry": {
          "type": "LineString",
          "coordinates": _getLineCoordinates(session.coordinates, line.line)
        },
        "properties" : {
          "id": "" + pointID + lineID,
          // "userId": session.userId,
          // "size" : line.size || 'NO SIZE',
          "color": getRGBA(line.color),
        }
      }
      features.push(lineFeature);
    });

  });



  return {
    "type": "FeatureCollection",
    "features" : features
  };

}

function _getLineCoordinates(startingCoordinate, lineTransform) {

  let lineCoordinates = []
  let arrayReducer = 1

  if      (lineTransform.length > 100) { arrayReducer = 5 }
  else if (lineTransform.length > 50) { arrayReducer = 3 }
  else if (lineTransform.length > 20) { arrayReducer = 2 }

  _.forEach(lineTransform, (dot, i) => {

    // dont include all array indexes
    if(i%arrayReducer !== 0) { return }


    const xPoint = Math.floor(lineTransform[i].x)

    const newLatOffset = 0.000004
    let newLat = startingCoordinate[0] + (newLatOffset * xPoint)

    const yPoint = Math.floor(lineTransform[i].y)

    const newLongOffset = 0.000008
    const gg = -0.007
    let newLong = startingCoordinate[1] + (newLongOffset * yPoint) + gg


    // add exact lat long to array
    // lineCoordinates.push([newLat,newLong])

    // rounded
    lineCoordinates.push([round(newLat, 4), round(newLong, 4)])


  });

  // const reduced = lineTransform.length - lineCoordinates.length
  // console.log('lineCoordinates.length',lineCoordinates.length)

  return lineCoordinates;

}

function round(x, n) {
  const tenN = Math.pow(10, n);
  return Math.round(x * tenN) / tenN;
}

// for good measure
function _cleanSessions(geoFire) {

    _.forEach(geoFire, (session,key) => {
      if(!session.l || !session.l[0] || !session.l[1]){
        // bad data. delete it
        delete geoFire[key]
      } else {
        // create coordinates array
        session.coordinates = [session.l[1], session.l[0] ];
      }
      // delete any sessions that dont have line color data
      if(!_.find(session.lines, 'color')) {
        console.log('no color data')
        delete geoFire[key]
      }
  });
}

export function getFeaturesForLineAnimation(session) {

  let returnObj = {}
  let emptyFeatures = []
  let featuresCoordinates = []


    const coordinates = [round(session.l[1], 6), round(session.l[0], 6)];

    // add lines to map
    _.map(session.lines, (line, lineKey) => {

      const lineFeature = {
        "type": "Feature",
        "geometry": {
          "type": "LineString",
          "coordinates": []
          // "coordinates": _getLineCoordinates(session.coordinates, line.line)
        },
        "properties" : {
          "id": lineKey,
          "userId": session.userId,
          "size" : line.size || 'NO SIZE',
          "timestamp" : session.timestamp,
          "color": getRGBA(line.color),
        }
      }
      emptyFeatures.push(lineFeature);
      featuresCoordinates.push(_getLineCoordinates(coordinates, line.line));
    });

    // console.log('emptyFeatures',emptyFeatures)
    returnObj.emptyFeatures = emptyFeatures;
    returnObj.featuresCoordinates = featuresCoordinates;
    returnObj.originCoordinates = coordinates;


  return returnObj;
}



// WEBPACK FOOTER //
// ./src/components/pages/NightMap/utils.js